<template>
  <div class="gp3">

    <!-- ════════════════════ HEADER ════════════════════ -->
    <header class="gp3-header">
      <div class="gp3-crumbs">
        <span>Finanzas</span>
        <span class="gp3-crumb-sep">›</span>
        <span class="gp3-crumb-current">Gastos de proveedor</span>
      </div>

      <div class="gp3-header-main">
        <div class="gp3-header-left">
          <h1 class="gp3-title">Gastos de proveedor</h1>
          <p class="gp3-subtitle">
            Control de facturas, pagos y vencimientos ·
            <strong>{{ formartedItems.length }}</strong> registros ·
            actualizado {{ liveTime }}
          </p>
        </div>
        <div class="gp3-header-actions">
          <button class="gp3-btn gp3-btn--ghost" @click="downloadExcell()">
            <i class="fa-solid fa-arrow-down"></i>
            <span>Excel</span>
          </button>
          <button class="gp3-btn gp3-btn--ghost" v-b-modal.modal-347>
            <i class="fa-solid fa-file-lines"></i>
            <span>Modelo 347</span>
          </button>
          <button class="gp3-btn gp3-btn--primary" @click="openModalNew()">
            <i class="fa-solid fa-plus"></i>
            <span>Nuevo gasto</span>
          </button>
        </div>
      </div>
    </header>

    <!-- ════════════════════ KPI CARDS ════════════════════ -->
    <div class="gp3-kpis">
      <div v-for="(k, i) in kpiCards" :key="i" class="gp3-kpi">
        <div class="gp3-kpi-top">
          <div class="gp3-kpi-icon" :class="'gp3-kpi-icon--' + k.tone">
            <i :class="k.icon"></i>
          </div>
          <div class="gp3-kpi-trend" :class="'gp3-kpi-trend--' + k.trendDir">
            <i :class="k.trendDir === 'up' ? 'fa-solid fa-arrow-trend-up' : k.trendDir === 'down' ? 'fa-solid fa-arrow-trend-down' : 'fa-solid fa-equals'"></i>
            <span>{{ k.trend }}</span>
          </div>
        </div>
        <div class="gp3-kpi-value">
          {{ k.value }}<span v-if="k.unit" class="gp3-kpi-unit">{{ k.unit }}</span>
        </div>
        <div class="gp3-kpi-label">{{ k.label }}</div>
        <svg class="gp3-kpi-spark" viewBox="0 0 120 28" preserveAspectRatio="none">
          <path
            :d="k.spark"
            :stroke="k.tone === 'danger' ? '#EF4444' : k.tone === 'amber' ? '#F59E0B' : k.tone === 'emerald' ? '#0E9F6E' : '#4F46E5'"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            fill="none"
          />
        </svg>
      </div>
    </div>

    <!-- ════════════════════ TRIMESTRES ════════════════════ -->
    <section class="gp3-card" v-if="mostrarTrimestres && dataTrimestre && dataTrimestre.length">
      <header class="gp3-card-head">
        <div>
          <h3 class="gp3-card-title">Vista trimestral</h3>
          <p class="gp3-card-sub">Acumulado por trimestre · ejercicio {{ anyoTrimestre }}</p>
        </div>
        <div class="gp3-card-actions">
          <v-select
            v-model="anyoTrimestre"
            :options="anyosDisponibles"
            :clearable="false"
            class="gp3-vselect gp3-vselect--year"
          />
          <button class="gp3-icon-btn" @click="copiarTrimestres" v-b-tooltip.hover title="Copiar">
            <i class="fa-regular fa-copy"></i>
          </button>
        </div>
      </header>
      <div class="gp3-trim-grid">
        <div v-for="(t, i) in dataTrimestre" :key="i" class="gp3-trim">
          <div class="gp3-trim-head">
            <span class="gp3-trim-mark">T{{ i + 1 }}</span>
            <span class="gp3-trim-name">{{ t.nombre }}</span>
          </div>
          <div class="gp3-trim-value">
            {{ formatearNumero(t.total) }}
            <span class="gp3-trim-currency">EUR</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ════════════════════ TABLE CARD ════════════════════ -->
    <section class="gp3-card gp3-card--table">
      <header class="gp3-card-head">
        <div>
          <h3 class="gp3-card-title">Registro de gastos</h3>
          <p class="gp3-card-sub">{{ formartedItems.length }} resultados</p>
        </div>
        <div class="gp3-search">
          <i class="fa-solid fa-magnifying-glass gp3-search-icon"></i>
          <input
            v-model="buscar"
            type="text"
            placeholder="Buscar por código, proveedor, notas..."
          />
          <button v-if="buscar" class="gp3-search-clear" @click="buscar = ''">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </header>

      <div class="gp3-filters">
        <div class="gp3-filter">
          <label class="gp3-filter-label">Estado de pago</label>
          <v-select
            v-model="pagadoSelect"
            :options="['Todos','Sin Pagar','Pagado']"
            :clearable="false"
            class="gp3-vselect"
          />
        </div>
        <div class="gp3-filter">
          <label class="gp3-filter-label">Desde</label>
          <flat-pickr v-model="fechaDesdeSelect" class="gp3-input" />
        </div>
        <div class="gp3-filter">
          <label class="gp3-filter-label">Hasta</label>
          <flat-pickr v-model="fechaHastaSelect" class="gp3-input" />
        </div>
        <div class="gp3-filter">
          <label class="gp3-filter-label">Empresa</label>
          <v-select
            v-model="empresaSelect"
            :options="empresas"
            label="nombre"
            :clearable="false"
            class="gp3-vselect"
          />
        </div>
        <div class="gp3-filter">
          <label class="gp3-filter-label">Proveedor</label>
          <v-select
            v-model="proveedorSelect"
            :options="proveedores"
            label="nombre"
            :clearable="false"
            class="gp3-vselect"
          />
        </div>
      </div>

      <!-- TABLE -->
      <div class="gp3-table-wrap">
        <table class="gp3-table">
          <thead>
            <tr>
              <th class="th-stripe"></th>
              <th>Empresa</th>
              <th>Proveedor</th>
              <th>Código</th>
              <th>Fecha</th>
              <th class="th-r">Total</th>
              <th class="th-r">Falta</th>
              <th>Vencimiento</th>
              <th class="th-c">Plazo</th>
              <th class="th-c">Notas</th>
              <th class="th-c">Estado</th>
              <th class="th-c">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in formartedItems"
              :key="item.id"
              :class="rowVariantClass(item._rowVariant)"
            >
              <td class="td-stripe">
                <span class="gp3-row-stripe" :class="rowVariantClass(item._rowVariant)"></span>
              </td>
              <td class="td-empresa">
                <div class="gp3-empresa-pill">
                  <span class="gp3-empresa-init" :class="'gp3-empresa-init--' + initialsTone(item.nombreEmpresa)">
                    {{ initials(item.nombreEmpresa) }}
                  </span>
                  <span class="gp3-empresa-name">{{ item.nombreEmpresa }}</span>
                </div>
              </td>
              <td class="td-prov">
                <span v-b-tooltip.hover :title="item.proveedorCompleto || ''">{{ item.proveedor }}</span>
              </td>
              <td class="td-codigo">{{ item.codigo }}</td>
              <td class="td-fecha">{{ item.fechaFactura || '—' }}</td>
              <td class="td-r td-amount">
                <strong>{{ item.total }}</strong>
                <span class="gp3-currency">{{ monedaSym(item.moneda) }}</span>
              </td>
              <td class="td-r" :class="{ 'is-debt': parseFloat(item.pendiente) > 0 }">
                <span v-if="parseFloat(item.pendiente) > 0">
                  <strong>{{ item.pendiente }}</strong>
                  <span class="gp3-currency">{{ monedaSym(item.moneda) }}</span>
                </span>
                <span v-else class="gp3-dim">—</span>
              </td>
              <td>
                <span class="gp3-vence" :class="'is-' + (item._rowVariant || 'none')">
                  {{ item.fechaVencimiento || '—' }}
                </span>
              </td>
              <td class="td-c">{{ item.plazo || '—' }}</td>
              <td class="td-c">
                <span
                  v-if="item.notas && item.notas.length"
                  class="gp3-note-icon"
                  v-b-tooltip.hover.v-primary
                  :title="item.notas"
                >
                  <i class="fa-regular fa-message"></i>
                </span>
                <span v-else class="gp3-dim">—</span>
              </td>
              <td class="td-c">
                <button
                  v-if="item.fechaPagado && item.fechaPagado.length"
                  class="gp3-status gp3-status--paid"
                  v-b-tooltip.hover.v-success
                  :title="item.fechaPagado"
                  @click="clickPagado(false, item.id)"
                >
                  <span class="gp3-status-dot"></span>
                  Pagado
                </button>
                <button
                  v-else
                  class="gp3-status gp3-status--unpaid"
                  @click="clickPagado(true, item.id)"
                >
                  <span class="gp3-status-dot"></span>
                  Pendiente
                </button>
              </td>
              <td class="td-c td-actions">
                <button class="gp3-icon-btn" v-b-tooltip.hover title="Editar" @click="editFactura(item)">
                  <i class="fa-solid fa-pen"></i>
                </button>
                <button v-if="item.tienePdf" class="gp3-icon-btn" v-b-tooltip.hover title="Descargar PDF" @click="descargarPDF(item)">
                  <i class="fa-solid fa-file-pdf"></i>
                </button>
                <button class="gp3-icon-btn gp3-icon-btn--danger" v-b-tooltip.hover.v-danger title="Eliminar" @click="deleteGasto(item.id, item.codigo)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="formartedItems.length === 0">
              <td colspan="12" class="gp3-empty">
                <div class="gp3-empty-inner">
                  <i class="fa-regular fa-folder-open"></i>
                  <p>No hay gastos registrados con los filtros actuales</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
    </section>

  </div>
</template>

    <script>
    import axios from '@axios'
    /*import VueApexCharts from 'vue-apexcharts'*/
    import { BTable , BFormCheckbox, BFormInput, BFormGroup, BModal, BCardText, BCardBody, BCard, BRow, BCol} from 'bootstrap-vue'
    // import BCardCode from '@core/components/b-card-code'
    import { $themeColors } from '@themeConfig'
    import { useTimeout } from '@vueuse/shared'
    import vSelect from 'vue-select'
    import { find, forEach } from 'postcss-rtl/lib/affected-props'
    import flatPickr from 'vue-flatpickr-component'

    import FullCalendar from '@fullcalendar/vue'

    import store from '@/store'
    import { onUnmounted } from '@vue/composition-api'
    import calendarStoreModule from './calendarStoreModule'
    import CalendarSidebar from './calendar-sidebar/CalendarSidebar.vue'
    import CalendarEventHandler from './calendar-event-handler/CalendarEventHandler.vue'
    import useCalendar from './useCalendar'

    import useCalendarSidebar from './calendar-sidebar/useCalendarSidebar'
    
      export default {
        components: {
            BFormCheckbox,
            BTable,
            BFormInput,
            BFormGroup,
            BCardText,
            BCardBody,
            BCard,
            BRow,
            BCol,
            vSelect,
            flatPickr,
            FullCalendar,
            CalendarSidebar,
            CalendarEventHandler,
        },
        data () {
          return {
            liveTime: '',
            liveTimeInterval: null,
            sortBy: "fechaVencimiento",
            columnasTable: [
            {
              key: "options",
              label: "",
              sortable: false,
              thStyle: { width: "7%" },
            },
            {
              key: "nombreEmpresa",
              label: "Empresa",
              sortable: true,
            },
            {
              key: "proveedor",
              label: "Proveedor",
              sortable: true,
            },            
            {
              key: "codigo",
              label: "Codigo",
              sortable: true,
            },            
            {
              key: "recibido",
              label: "Recibido",
              sortable: true,
            },,{
              key: "fechaFactura",
              label: "Fecha",
              sortable: true,
            },{
              key: "total_moneda",
              label: "Total",
              sortable: true,
            },{
              key: "pendiente",
              label: "Falta",
              sortable: true,
            },{
              key: "fechaVencimiento",
              label: "Vencimiento",
              sortable: true,
            },{
              key: "plazo",
              label: "Plazo",
              sortable: true,
            },{
              key: "notas",
              label: "Notas",
              sortable: true,
            },{
              key: "pagado",
              label: "",
              sortable: false,
            }],
            columnasTablePedidos: [
            {
              key: "checking",
              label: "",
              sortable: false,
              thStyle: { width: "7%" },
            },
            {
              key: "options",
              label: "",
              sortable: false,
              thStyle: { width: "7%" },
            },
            {
              key: "codigo",
              label: "Codigo",
              sortable: true,
            },
            {
              key: "totalMateriales",
              label: "Materiales",
              sortable: true,
            },
            {
              key: "fecha",
              label: "Fecha",
              sortable: true,
            },{
              key: "pedido",
              label: "Pedido",
              sortable: true,
            }],
            columnasMateriales: [          
            {
              key: "nombre",
              label: "Nombre",
              sortable: false,
            },
            {
              key: "color",
              label: "Color",
              sortable: false,
            },
            {
              key: "cantidad",
              label: "UD",
              sortable: false,
            },{
              key: "udrecibido",
              label: "Recibido",
              sortable: true,
            }],
            buscar: "",
            countItemView: 100,
            nextScrollItemView: 40,
            defaultItemView: 100,
            lastSort: null,
            facturasBusqueda: [],
            allFacturasBusqueda: [],
            listadoFacturas: [],
            fechaDesdeSelect: '',
            fechaHastaSelect: '',
            categorias: [],
            categoriaSelect: [],
            pagadoSelect: 'Todos',
            empresaSelect: '',
            proveedorSelect: '',
            clients: [],
            empresas: [],
            dataResumen: [{icon:'fa-solid fa-file-invoice-dollar', nombre: 'Gastos', valor: 22, variant: 'primary', moneda: ''},
                          {icon:'fa-solid fa-money-bill-transfer', nombre: 'Pendiente', valor: 22, variant: 'danger', moneda: '€'},
                          {icon:'fa-solid fa-hand-holding-dollar', nombre: 'Pagado', valor: 22, variant: 'success', moneda: '€'},
                          {icon:'fa-solid fa-money-bill', nombre: 'Total', valor: 22, variant: 'info', moneda: '€'},],
            tituloModal: "Añadir gastos",
            listadoProveedores: [],
            proveedores: [],
            textBotonGuardar: "Crear nuevo",
            inputProveedor: "",
            inputCodigo: "",
            inputCantidad: 0,
            inputFecha: "",
            inputFechaVencimiento: "",
            inputPlazo: "",
            inputNotas: "",
            inputEmpresa: "",
            inputPendiente: "",
            inputPdfFactura: true,
            empresasGastos: [],
            idEdit: 0,
            inputPDF: [],
            base64PDF: '',
            itemSelect: null,
            inputFechaNueva: '',
            vistaLista: true,
            listadoPedidos: [],
            listadoPedidosMostrar: [],
            nuevoGasto: true,
            cargando: true,
            selectedCurrency: 'EUR',
            currencyOptions: [
              { text: 'Euro (€)', value: 'EUR' },
              { text: 'Libra (£)', value: 'GBP' },
              { text: 'Dólar ($)', value: 'USD' }
            ],
            tiposCambioAEuro: {
              EUR: 1,
              USD: 0.85,
              GBP: 1.16
            },
            nuevaFechaPagado: '',
            facturaActual: null,
            mostrarTrimestres: false,
            dataTrimestre: null,
            anyoTrimestre: new Date().getFullYear(),
            anyosDisponibles: [2021, 2022, 2023, 2024, 2025, 2026],
            data347: [],
            anyo347: new Date().getFullYear()
          }
        },
        computed: {
          formartedItems () {
            if (!this.facturasBusqueda) return []
            return this.facturasBusqueda.map(item => {
              item._rowVariant  = this.getVariant(item.fechaVencimiento, item.fechaPagado)
              return item
            })
          },
          total347() {
            return this.data347.reduce((acc, p) => {
              acc.t1 += p.trimestre1;
              acc.t2 += p.trimestre2;
              acc.t3 += p.trimestre3;
              acc.t4 += p.trimestre4;
              acc.total += p.total;
              return acc;
            }, { t1: 0, t2: 0, t3: 0, t4: 0, total: 0 });
          },
          // ════ V2 modern ERP — KPI cards ════
          kpiCards() {
            const dr = this.dataResumen || [];
            const get = (i) => {
              const item = dr[i];
              if (!item) return '0';
              if (item.valor && typeof item.valor === 'object') {
                if (item.valor.euro && item.valor.euro !== '0,00') return item.valor.euro;
                if (item.valor.libra && item.valor.libra !== '0,00') return '£' + item.valor.libra;
                return '0,00';
              }
              return item.valor || '0';
            };
            return [
              {
                label: 'Total de gastos',
                value: get(0),
                unit: '',
                icon: 'fa-solid fa-file-invoice-dollar',
                tone: 'indigo',
                trend: 'Periodo',
                trendDir: 'flat',
                spark: 'M0 18 Q15 12 30 14 T60 10 T90 16 T120 8'
              },
              {
                label: 'Pendiente de pago',
                value: get(1),
                unit: '€',
                icon: 'fa-solid fa-money-bill-transfer',
                tone: 'danger',
                trend: 'Sin pagar',
                trendDir: 'down',
                spark: 'M0 8 Q15 14 30 12 T60 18 T90 14 T120 22'
              },
              {
                label: 'Ya pagado',
                value: get(2),
                unit: '€',
                icon: 'fa-solid fa-hand-holding-dollar',
                tone: 'emerald',
                trend: 'Liquidado',
                trendDir: 'up',
                spark: 'M0 22 Q15 18 30 14 T60 12 T90 8 T120 6'
              },
              {
                label: 'Volumen total',
                value: get(3),
                unit: '€',
                icon: 'fa-solid fa-chart-column',
                tone: 'ink',
                trend: 'Acumulado',
                trendDir: 'up',
                spark: 'M0 20 Q15 16 30 18 T60 12 T90 10 T120 6'
              }
            ];
          }
        },
        methods:{
          // ════ V2 helpers ════
          updateLiveTime() {
            const d = new Date();
            const h = String(d.getHours()).padStart(2,'0');
            const m = String(d.getMinutes()).padStart(2,'0');
            this.liveTime = 'hoy ' + h + ':' + m;
          },
          initials(name) {
            if (!name) return '·';
            const parts = String(name).trim().split(/\s+/);
            if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
            return (parts[0][0] + parts[1][0]).toUpperCase();
          },
          initialsTone(name) {
            if (!name) return 'ink';
            const tones = ['indigo', 'emerald', 'amber', 'sky', 'coral', 'ink'];
            let hash = 0;
            for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
            return tones[hash % tones.length];
          },
          kpiValue(item) {
            if (!item) return '0,00';
            if (item && item.valor && typeof item.valor === 'object') {
              if (item.valor.euro && item.valor.euro !== '0,00') return item.valor.euro;
              if (item.valor.libra && item.valor.libra !== '0,00') return '£' + item.valor.libra;
              return '0,00';
            }
            return item.valor || '0';
          },
          monedaSym(moneda) {
            if (moneda === 'GBP') return '£';
            if (moneda === 'USD') return '$';
            return '€';
          },
          rowVariantClass(variant) {
            if (!variant) return '';
            return 'row-' + variant;
          },
          // ════ original methods ════
          formatearNumero(numero) {
            return numero.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
          },
          getVariant (fecha, fechaPagado) {

            if(fecha == '' || fechaPagado.length > 0)
              return '';

            const fechaActual = new Date();
            const fechaObjetivo = new Date(fecha);
            const diferenciaMilisegundos = fechaObjetivo - fechaActual;
            const diasFaltantes = Math.ceil(diferenciaMilisegundos / (1000 * 60 * 60 * 24));

            //Vencida - Rojo
            //15 al 1 - Naranja o Amarillo
            //16 en adelante - Verde

            if(diasFaltantes > 15)
              return 'success';
            else if(diasFaltantes > 0)
              return 'warning';
            else if(diasFaltantes <= 0)
              return 'danger';            

           
          },
          loadItems(){

            axios.post("/uso", {seccion:"gastosProveedor"});
    
             function ponerMoneda(total, moneda){
              if(moneda == "€")
                return total +''+ moneda
              else
                return moneda +''+ total;      
            }

              axios
                .get("/shopify/exchange/USD")
                .then(response => {
                    return response.data;
                })
                .then(res => {
                  this.tiposCambioAEuro.USD = res.rates.EUR;
                });

              axios
                .get("/shopify/exchange/GBP")
                .then(response => {
                    return response.data;
                })
                .then(res => {
                  this.tiposCambioAEuro.GBP = res.rates.EUR;
                });

                Promise.all([
                    axios.get("/finanzas/empresas"),
                    axios.get("/proveedores"),
                    axios.get("/finanzas/gastos"),
                    axios.get("/materiales/pedidos")
                ]).then(responses => {
                    const [empresasResponse, proveedoresResponse, gastosResponse, pedidosResponse] = responses;

                    // Empresas
                    const empresasData = empresasResponse.data;
                    this.empresasGastos = JSON.parse(JSON.stringify(empresasData));
                    this.empresas = empresasData;
                    this.empresas.unshift({id: 0, nombre: 'Todas'})
                    this.inputEmpresa = this.empresas[1];

                    // Proveedores
                    const proveedoresData = proveedoresResponse.data;
                    this.listadoProveedores = proveedoresData;
                    this.listadoProveedores.sort((a, b) => a.nombre.localeCompare(b.nombre));
                    this.listadoProveedores.forEach(proveedor => {
                      if (proveedor.nickname != '') {
                          proveedor.nombre = proveedor.nickname;
                      }
                    });
                    this.proveedores = JSON.parse(JSON.stringify(proveedoresData));
                    this.proveedores.sort((a, b) => a.nombre.localeCompare(b.nombre));
                    this.proveedores.unshift({id: 0, nombre: 'Todos'})

                    // Defaults antes de cargar filtro
                    if(this.empresaSelect == '')
                      this.empresaSelect = this.empresas[0];
                    if(this.proveedorSelect == '')
                      this.proveedorSelect = this.proveedores[0];

                    // Restaurar filtros guardados (usa referencias del array real)
                    this.cargarFiltro();

                    // Manejo de la respuesta de gastos
                    this.listadoFacturas = gastosResponse.data;
                    this.listadoFacturas = this.listadoFacturas.sort((a, b) => a.fechaVencimiento - b.fechaVencimiento);

                    //console.log(this.listadoFacturas);

                    // Manejo de la respuesta de pedidos
                    this.listadoPedidos = pedidosResponse.data;
                    this.listadoPedidos.sort((a, b) => a.fecha - b.fecha);

                    // Aquí puedes llamar a una función que deseas ejecutar después de que se completen ambas solicitudes
                    this.listadoFacturas.forEach(gasto => {
                      gasto.proveedorCompleto = gasto.proveedor;
                      if(gasto.proveedor.length > 20)
                      {
                        gasto.proveedor = gasto.proveedor.substring(0, 20) + "...";
                      }



                      let proveedorFind = this.listadoProveedores.find(prov => prov.id == gasto.idProveedor);
                      if(proveedorFind)
                      {
                        gasto.cifProveedor = proveedorFind.cif;
                        if(proveedorFind.nickname != '')
                          gasto.proveedor = proveedorFind.nickname;
                      }
                        

                      let pedidosAsociados = this.listadoPedidos.filter(pedido => pedido.idGasto == gasto.id);

                      let totalPedido = 0;
                      let totalRecibido = 0;

                      pedidosAsociados.forEach(pedido => {
                        pedido.listaMateriales.forEach(material => {
                          totalPedido += parseInt(material.cantidad);
                          totalRecibido += parseInt(material.cantidadRecibida);
                        });
                      });

                      if(totalPedido != 0)
                        gasto.recibido = totalPedido +' / '+totalRecibido;
                      else
                        gasto.recibido = '';
                      
                    });

                    //console.log(this.listadoFacturas);

                    this.facturasBusqueda = this.listadoFacturas;
                    this.buscarFuncion();
                }).catch(error => {
                    console.error("Error al realizar las solicitudes: ", error);
                });

    
          },
          openModalNew(){
            this.nuevoGasto = true;
            //this.refetchEvents();
            this.idEdit = 0;
            this.inputProveedor = "";
            this.inputFecha = "";
            this.inputCodigo = "";
            this.inputCantidad = "";
            this.inputFechaVencimiento = "";
            this.inputPlazo = "";
            this.inputNotas = "";
            this.inputPendiente = "";
            this.inputPdfFactura = true;
            this.textBotonGuardar = "Crear nuevo";
            this.itemSelect = null;
            this.selectedCurrency = 'EUR';
            this.$bvModal.show('modal-add');
            
          },
          editFactura(item){
            this.nuevoGasto = false;
            this.idEdit = item.id;
            this.textBotonGuardar = "Guadar cambios";
            this.inputProveedor = this.listadoProveedores.find(element => element.id === item.idProveedor);
            this.inputEmpresa = this.empresas.find(element => element.id === item.idEmpresa);
            this.inputCodigo = item.codigo;
            this.inputCantidad = item.total;
            this.inputFecha = item.fechaFactura;
            this.inputFechaVencimiento = item.fechaVencimiento;
            this.inputPlazo = item.plazo;
            this.inputNotas = item.notas;
            this.inputPendiente = item.pendiente;
            this.selectedCurrency = item.moneda || 'EUR';
            //console.log(item.moneda);
            if(item.pdfFactura == 1)
              this.inputPdfFactura = true;
            else
              this.inputPdfFactura = false;
            this.itemSelect = item;
            this.$bvModal.show('modal-add');
          },
          deleteGasto(id, codigo){
            this.$swal({
              title: 'Estas seguro que quieres borrar la factura: ' + codigo,
              icon: 'error',
              showCancelButton: true,
              //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
              confirmButtonText: 'Si, borrar',
              cancelButtonText: 'No',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
              },
              buttonsStyling: false,
            }).then(result => {

              if(result.isConfirmed)
              {

                axios
                .delete("/finanzas/gastos/"+id)
                .then(response => {
                  return response.data;
                })
                .then(res => {
                    //this.listadoFacturas
                    this.$swal({
                        icon: 'success',
                        title: 'La factura se ha borrado correctamente: ' + codigo,
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })

                    this.listadoFacturas = this.listadoFacturas.filter(item => item.id !== id);
                    this.facturasBusqueda = this.facturasBusqueda.filter(item => item.id !== id);
                    this.calcularResumen();
                    this.buscarFuncion();
                  }).
                  catch(execption => {
                    console.log(execption);
                    this.$swal({
                        icon: 'danger',
                        title: 'Se ha producido un error al borrar la factura.' ,
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })
                  });

              }

            })
          },
          loadMore() {
            this.countItemView += this.nextScrollItemView;
            this.buscarFuncion();
          },
          sortChanged(e) {
            this.lastSort = e;
            this.buscarFuncion();
          },
          convertToBase64() {
            return new Promise((resolve) => {
              if (this.inputPDF instanceof Blob) {
                const fileReader = new FileReader();

                fileReader.onload = () => {
                  this.base64PDF = fileReader.result;
                  resolve();
                };

                // Leer el contenido del archivo PDF como una URL de datos
                fileReader.readAsDataURL(this.inputPDF);
              } else {
                resolve();
              }
            });
          },
          descargarPDF(data) {
            if (data.pdf && data.pdf.length > 0) {
              let textoProveedor = data.proveedor.replaceAll(' ','_');
              const link = document.createElement('a');
              link.href = data.pdf;
              link.download = textoProveedor + '_' +data.codigo + '.pdf';
              link.target = '_blank'; // Abre el enlace en una nueva pestaña
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {

              axios
                .get("/finanzas/gastos/pdf/"+data.id)
                .then(response => {
                    return response.data;
                })
                .then(pdf => {

                  let textoProveedor = data.proveedor.replaceAll(' ','_');
                  const link = document.createElement('a');
                  link.href = pdf;
                  link.download = textoProveedor + '_' +data.codigo + '.pdf';
                  link.target = '_blank';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);

                  data.pdf = pdf;
                  
                });
              
            }
          },
          async guardarPediente(similaresAceptados = false){

            if(!similaresAceptados)
              await this.convertToBase64();

            //Comprobar el total con el proveedor si ya existe.
            //al nombre del documento añadir el numero.
            
            let error = false;
            
            if(this.inputProveedor == '')
            {
              this.$bvToast.toast(`No se ha seleccionado el proveedor.`, {
              title: 'Faltan datos',
                      variant: 'danger',
                      solid: true,
                    })

              error = true;
            }

            if(this.inputCantidad == '')
            {
              this.$bvToast.toast(`No se ha rellenado la cantidad.`, {
              title: 'Faltan datos',
                      variant: 'danger',
                      solid: true,
                    })

              error = true;
            }

            if(this.inputCodigo == '')
            {
              this.$bvToast.toast(`No se ha rellenado el codigo.`, {
              title: 'Faltan datos',
                      variant: 'danger',
                      solid: true,
                    })

              error = true;
            }

            if(this.inputFecha == '')
            {
              this.$bvToast.toast(`No se ha seleccionado la fecha.`, {
              title: 'Faltan datos',
                      variant: 'danger',
                      solid: true,
                    })

              error = true;
            }

            if(error)
              return;

            if(this.itemSelect != null && this.base64PDF == '' && this.itemSelect.pdfFactura)
            {
              this.base64PDF = this.itemSelect.pdf;
            }

            //Fecha vencimiento
            this.inputFechaVencimiento = '';

            if(this.inputPlazo == '')
              this.inputPlazo = '0';
            else if (isNaN(parseInt(this.inputPlazo))) {
              this.inputPlazo = '0';
            }

            /*if(this.inputPlazo.length == '')
            {
              this.inputPlazo = '0';
            }*/

            var fechaActual = new Date(this.inputFecha);
            fechaActual.setDate(fechaActual.getDate() + parseInt(this.inputPlazo));
            const dia = fechaActual.getDate().toString().padStart(2, '0');
            const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
            const anio = fechaActual.getFullYear().toString();
            this.inputFechaVencimiento = `${anio}-${mes}-${dia}`;

            let data = {
                id: this.idEdit,
                idEmpresa: this.inputEmpresa.id,
                idProveedor: this.inputProveedor.id,
                fechaFactura: this.inputFecha,
                codigo: this.inputCodigo,
                total: this.inputCantidad,
                fechaVencimiento: this.inputFechaVencimiento,
                plazo: this.inputPlazo,
                notas: this.inputNotas,
                nombreEmpresa: this.inputEmpresa.nombre,
                proveedor: this.inputProveedor.nombre,
                pdf: this.base64PDF,
                fechaPagado: '',
                pendiente: this.inputPendiente,
                pdfFactura: this.inputPdfFactura,
                tienePdf: this.base64PDF && this.base64PDF.length > 10 ? 1 : (this.itemSelect && this.itemSelect.tienePdf ? 1 : 0),
                moneda: this.selectedCurrency
            }        

            let similares = "";

            if(!similaresAceptados)
            {
              //agregar fecha a la comprobacion
                          
              this.listadoFacturas.forEach(gasto => {
                if(gasto.total == data.total && gasto.idEmpresa == data.idEmpresa && gasto.idProveedor == data.idProveedor && gasto.codigo.replaceAll(' ','') == data.codigo.replaceAll(' ',''))
                {
                  similares += gasto.codigo + '<br>';
                }
              });
            }

            if(!similaresAceptados && similares != '' && data.id == 0)
            {
              this.$swal({
                title: 'Existes estos gastos con los mismos datos',
                html: `Gastos similares:<br>${similares}`,
                icon: 'error',
                showCancelButton: true,
                //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
                confirmButtonText: 'Si, continuar',
                cancelButtonText: 'No',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(result => {

                if(result.isConfirmed)
                  this.guardarPediente(true)
              })
            }
            else
            {
              function updatePedido(idGasto, lista){

                lista.forEach(pedido => {

                  if(pedido.check)
                  {
                    pedido.listaMateriales.forEach(element => {
                      if(element.cantidadFacturada != undefined && element.cantidadFacturada != '')
                        element.cantidadFacturada = parseInt(element.cantidadFacturada);
                      else
                        element.cantidadFacturada = element.cantidad;
                    });

                    let data = {
                      id: pedido.id,
                      idGasto,
                      lista: pedido.listaMateriales
                    }

                    pedido.idGasto = idGasto;

                    axios
                    .put("/materiales/pedidos/enlazarGasto", data)
                    .then(response => {
                        return response.data;
                    })
                    .then(res => {

                    });
                  }

                });

              }

                if(data.id == 0)
                {
                  axios
                    .post("/finanzas/gastos", data)
                    .then(response => {
                        return response.data;
                    })
                    .then(res => {

                        data.id = res.insertId;

                        updatePedido(data.id, this.listadoPedidosMostrar );

                        this.listadoPedidosMostrar.forEach(pedido => {

                          if(pedido.check)
                          {
                            const index = this.listadoPedidos.findIndex(pedidoActualizar => pedidoActualizar.id === pedido.id);
                            if (index !== -1) {
                              this.listadoPedidos[index].idGasto = data.id;
                            }

                          }
                          
                        });

                        this.listadoFacturas.unshift(data);

                       
                        this.$bvModal.hide('modal-add');

                        this.buscarFuncion(this.listadoFacturas);

                        //this.refetchEvents();
                        /*this.fetchCalendarOptions();
                        this.fetchCalendarsColor();*/

                        this.$swal({
                            icon: 'success',
                            title: data.codigo,
                            text: 'Se ha agregado correctamente.',
                            customClass: {
                            confirmButton: 'btn btn-success',
                            },
                        })
                    })
                    .catch(error=> {
                      console.log(error);
                      this.$swal({
                            icon: 'error',
                            title: 'Se ha producito un error.',
                            text: 'Prueba a escribir el codigo a mano.',
                            customClass: {
                            confirmButton: 'btn btn-danger',
                            },
                        })
                    });
                  }
                else{

                  axios
                    .put("/finanzas/gastos", data)
                    .then(response => {
                        return response.data;
                    })
                    .then(res => {

                      data.fechaPagado = this.itemSelect.fechaPagado;

                      updatePedido(data.id, this.listadoPedidosMostrar);

                      this.listadoFacturas.forEach((element, index) => {
                          if (element.id == data.id) {
                              this.listadoFacturas[index] = data;
                          }
                      });

                      this.listadoPedidosMostrar.forEach(pedido => {

                        if(pedido.check)
                        {
                          const index = this.listadoPedidos.findIndex(pedidoActualizar => pedidoActualizar.id === pedido.id);
                          if (index !== -1) {
                            this.listadoPedidos[index].idGasto = data.id;
                          }

                        }

                      });

                      this.$bvModal.hide('modal-add');

                      //this.refetchEvents();
                      //this.fetchCalendarOptions();
                      //this.fetchCalendarsColor();

                      this.buscarFuncion(this.listadoFacturas);

                      this.$swal({
                        icon: 'success',
                        title: data.codigo,
                        text: 'Se ha actualizado correctamente.',
                        customClass: {
                        confirmButton: 'btn btn-success',
                        },
                      })
                    });

                }                
            }
          },
          editarFechaPagadoSwal(data){

            this.$swal({
                title: 'Seleccionar nueva fecha. YYYY-MM-DD',
                icon: 'info',
                input: "text",              
                //inputValue: data.fechaPagado || new Date().toISOString().substr(0, 10),
                inputAttributes: {
                  type: 'date',
                },  
                showCancelButton: true,              
                confirmButtonText: 'Si, guardar',
                cancelButtonText: 'No',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(result => {

                if(result.isConfirmed)
                {

                  axios
                    .put("/finanzas/gastos/fechapagado", {fechaPagado: result.value, id: data.id})
                    .then(response => {
                      return response.data;
                    })
                    .then(res => {
                        this.facturasBusqueda.forEach(item => {
                          if(item.id == data.id)
                            item.fechaPagado = result.value;
                        });
                        this.calcularResumen();
                      });


                }

              })            
          },
          clickPagado(estado, id){

            axios
              .put("/finanzas/gastos/pagado", {pagado: estado, id})
              .then(response => {
                return response.data;
              })
              .then(res => {
                  this.facturasBusqueda.forEach(item => {
                    if(item.id == id)
                      item.fechaPagado = res;
                  });

                  this.listadoFacturas.forEach(item => {
                    if(item.id == id)
                      item.fechaPagado = res;
                  });
                  this.calcularResumen();
                });
          },
          buscarFuncion(items = this.listadoFacturas ){

            this.mostrarTrimestres = false;

            let auxSorting = JSON.parse(JSON.stringify(items));

            this.facturasBusqueda = [];

            let aux = auxSorting.filter(factura => {
              const pagadoCondicion = 
                this.pagadoSelect === "Todos" ||
                (this.pagadoSelect === "Sin Pagar" && factura.fechaPagado === '') ||
                (this.pagadoSelect === "Pagado" && factura.fechaPagado !== '');    
    
              const empresaCondicion = this.empresaSelect.id === 0 || this.empresaSelect.id === factura.idEmpresa;
              const proveedorCondicion = this.proveedorSelect.id === 0 || this.proveedorSelect.id === factura.idProveedor;
    
              const textoCondicion = factura.codigo.toLowerCase().includes(this.buscar.toLowerCase()) || factura.proveedor.toLowerCase().includes(this.buscar.toLowerCase())
              || factura.nombreEmpresa.toLowerCase().includes(this.buscar.toLowerCase()) || (factura.cifProveedor && factura.cifProveedor.toLowerCase().includes(this.buscar.toLowerCase()))
              || (factura.textoPdf && factura.textoPdf.toLowerCase().includes(this.buscar.toLowerCase()));
    
              const fechaDesdeCondicion = !this.fechaDesdeSelect || new Date(factura.fechaFactura) >= new Date(this.fechaDesdeSelect);
              const fechaHastaCondicion = !this.fechaHastaSelect || new Date(factura.fechaFactura) <= new Date(this.fechaHastaSelect);
    
              return pagadoCondicion && textoCondicion && empresaCondicion && proveedorCondicion && fechaDesdeCondicion && fechaHastaCondicion ;
            });

            // Array para objetos con fechaPagado vacía
            const objetosSinFechaPagado = aux.filter(objeto => !objeto.fechaPagado);

            objetosSinFechaPagado.sort((a, b) => {
              const dateA = new Date(a.fechaVencimiento);
              const dateB = new Date(b.fechaVencimiento);
              return dateA - dateB;
            });

            // Array para objetos con fechaPagado definida
            const objetosConFechaPagado = aux.filter(objeto => {
              if(Date.parse(objeto.fechaPagado))
                return objeto.fechaPagado;
              else
                return false;
            });

            // Ordenar objetos con fechaPagado definida por fechaPagado
            objetosConFechaPagado.sort((a, b) => {
              const dateA = new Date(a.fechaPagado);
              const dateB = new Date(b.fechaPagado);
              return dateB - dateA;
            });

            const objetosConFechaPagadoNoFecha = aux.filter(objeto => {
              // Verificar si fechaPagado está definido y no es una fecha válida
              return objeto.fechaPagado && isNaN(Date.parse(objeto.fechaPagado));
            });

            // Concatenar los dos arrays para obtener el resultado final
            const resultadoFinal = [...objetosSinFechaPagado, ...objetosConFechaPagado, ...objetosConFechaPagadoNoFecha];

            //this.facturasBusqueda = resultadoFinal;

            this.allFacturasBusqueda = resultadoFinal;

            this.facturasBusqueda = resultadoFinal.slice(0,this.countItemView);

            this.calcularResumen();

            this.calcularTrimestre();
          },
          downloadExcell(){
            var csv = "Empresa;Proveedor;Codigo;Fecha;IVA;Total;Falta;Vencimiento;Plazo;Notas;Pagado"+"\n";

            this.allFacturasBusqueda.forEach(factura => {         
              let iva = parseFloat(factura.total)-(parseFloat(factura.total)/1.21);
              iva = iva.toFixed(2);
                csv += factura.nombreEmpresa + ";" + factura.proveedorCompleto + ";" + factura.codigo + ";" + factura.fechaFactura+ ";"  + iva+ ";" 
                + factura.total+ ";" + factura.pendiente+ ";" + factura.fechaVencimiento+ ";" + factura.plazo + ";" + factura.notas+";" + factura.fechaPagado+"\n";
            });

            var encodedUri = encodeURI(csv);
            var link = document.createElement("a");
            link.setAttribute("href", 'data:text/csv;charset=utf-8,'+encodedUri);
            link.setAttribute("download", "gastos_proveedor.csv");
            document.body.appendChild(link); 
            link.click();
          },
          recalcularDatos()
          {
            this.cargarColumnas();

            this.buscarFuncion();
          },
          calcularResumen() {
            let facturas = 0;
            let pendienteDineroEuro = 0;
            let cobradoDineroEuro = 0;
            let totalEuro = 0;

            this.allFacturasBusqueda.forEach(item => {
              facturas++;

              let importeTotal = parseFloat(item.total);
              let pagadoTotal = parseFloat(item.total) - parseFloat(item.pendiente);
              if (item.pendiente !== '')
                importeTotal = parseFloat(item.pendiente);

              // Usar EUR como default si moneda es null/undefined
              const moneda = item.moneda ?? 'EUR';
              const factorCambio = this.tiposCambioAEuro[moneda] || 1;
              const importeEnEuros = importeTotal * factorCambio;

              if (item.fechaPagado === '') {
                pendienteDineroEuro += importeEnEuros;
                if(item.pendiente != '')
                {
                  cobradoDineroEuro += pagadoTotal * factorCambio;
                }                
                
              } else {                
                cobradoDineroEuro += importeEnEuros;
              }

              totalEuro += importeEnEuros;
            });


            this.dataResumen[0].valor = facturas;
            /*this.dataResumen[1].valor = pendienteDineroEuro.toFixed(2);
            this.dataResumen[2].valor = cobradoDineroEuro.toFixed(2);
            this.dataResumen[3].valor = totalEuro.toFixed(2);*/

            this.dataResumen[1].valor = pendienteDineroEuro.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
            this.dataResumen[2].valor = cobradoDineroEuro.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
            this.dataResumen[3].valor = totalEuro.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
    
          },
          guardarFiltro(){

            let datos = {
              pagado: this.pagadoSelect,
              desde: this.fechaDesdeSelect,
              hasta: this.fechaHastaSelect,
              empresa: this.empresaSelect,
              proveedor: this.proveedorSelect,
              buscar: this.buscar
            }

            const date = new Date();
            let hours = 12;
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = 'gastosProveedor' + "=" + JSON.stringify(datos) + ";" + expires + ";path=/";

          },
          cargarFiltro(){

            let datos = null;

            const nameEQ = 'gastosProveedor' + "=";
            const cookiesArray = document.cookie.split(';');
            for(let i = 0; i < cookiesArray.length; i++) {
                let cookie = cookiesArray[i];
                while (cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length);
                if (cookie.indexOf(nameEQ) == 0) {
                  datos =  JSON.parse(cookie.substring(nameEQ.length, cookie.length));
                }
            }

            if(datos != null)
            {
                this.pagadoSelect = datos.pagado;
                this.fechaDesdeSelect = datos.desde;
                this.fechaHastaSelect = datos.hasta;
                if(datos.empresa && datos.empresa.id != null) {
                  const emp = this.empresas.find(e => e.id === datos.empresa.id);
                  if(emp) this.empresaSelect = emp;
                }
                if(datos.proveedor && datos.proveedor.id != null) {
                  const prov = this.proveedores.find(p => p.id === datos.proveedor.id);
                  if(prov) this.proveedorSelect = prov;
                }
                this.buscar = datos.buscar;
            }

          },
          editarFechaPagado(factura) {
            this.facturaActual = factura;
            this.nuevaFechaPagado = factura.fechaPagado || new Date().toISOString().substr(0, 10);

            this.$refs.modalFechaPagado.show();
          },
          focusInput() {
            this.$nextTick(() => {
              const el = document.getElementById('input-fecha');
              if (!el) return;

              if (typeof el.showPicker === 'function') {
                el.showPicker();
                return;
              }

              el.focus();
              el.click();
            });
          },
          guardarFechaPagado(){

            axios
              .put("/finanzas/gastos/fechapagado", {fechaPagado: this.nuevaFechaPagado, id: this.facturaActual.id})
              .then(response => {
                return response.data;
              })
              .then(res => {
                  this.facturasBusqueda.forEach(item => {
                    if(item.id == this.facturaActual.id)
                      item.fechaPagado = this.nuevaFechaPagado;
                  });
                  this.$swal({
                        icon: 'success',
                        title: 'Se ha actualizado la fecha de pago correctamente',
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })
                  this.calcularResumen();
                }).catch(error => {
                  console.error("Error al actualizar la fecha de pago:", error);
                  this.$swal({
                        icon: 'error',
                        title: 'Se ha producido un error al actualizar la fecha de pago.',
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })
                });

            /*console.log(this.facturaActual.fechaPagado);
            console.log(this.nuevaFechaPagado);*/

          },
          calcularTrimestre(){

            let anyo = this.anyoTrimestre;

            let trimestres = [
              {
                nombre: 'Enero-Febrero-Marzo',
                total: 0
              },
              {
                nombre: 'Abril-Mayo-Junio',
                total: 0
              },
              {
                nombre: 'Julio-Agosto-Septiembre',
                total: 0
              },
              {
                nombre: 'Octubre-Noviembre-Diciembre',
                total: 0
              }
            ]

            let items = JSON.parse(JSON.stringify(this.listadoFacturas));

            items.forEach(factura => {

              const proveedorCondicion = this.proveedorSelect.id === factura.idProveedor;
              const anyoCondicion = factura.fechaFactura.includes(anyo);

              if(proveedorCondicion && anyoCondicion)
              {
                if(factura.fechaFactura.includes('-01-') || factura.fechaFactura.includes('-02-') || factura.fechaFactura.includes('-03-'))
                {
                  trimestres[0].total +=  parseFloat(factura.total);
                }
                else if(factura.fechaFactura.includes('-04-') || factura.fechaFactura.includes('-05-') || factura.fechaFactura.includes('-06-'))
                {
                  trimestres[1].total +=  parseFloat(factura.total);
                }
                else if(factura.fechaFactura.includes('-07-') || factura.fechaFactura.includes('-08-') || factura.fechaFactura.includes('-09-'))
                {
                  trimestres[2].total +=  parseFloat(factura.total);
                }
                else if(factura.fechaFactura.includes('-10-') || factura.fechaFactura.includes('-11-') || factura.fechaFactura.includes('-12-'))
                {
                  trimestres[3].total +=  parseFloat(factura.total);
                }
                
              }

            });

            this.dataTrimestre = trimestres;

            if(this.proveedorSelect.id != 0)
              this.mostrarTrimestres = true;

          },
          calcular347(){
            let resultado = [];

            this.proveedores.forEach(proveedor => {
              if(proveedor.id === 0) return;

              let proveedorData = this.listadoProveedores.find(p => p.id === proveedor.id);
              let cif = proveedorData && proveedorData.cif ? proveedorData.cif : '';

              let data = { nombre: proveedor.nombre, cif: cif, trimestre1: 0, trimestre2: 0, trimestre3: 0, trimestre4: 0, total: 0 };

              this.listadoFacturas.forEach(factura => {
                if(proveedor.id !== factura.idProveedor) return;
                if(!factura.fechaFactura.includes(this.anyo347)) return;

                let importe = parseFloat(factura.total);
                if(factura.fechaFactura.includes('-01-') || factura.fechaFactura.includes('-02-') || factura.fechaFactura.includes('-03-'))
                  data.trimestre1 += importe;
                else if(factura.fechaFactura.includes('-04-') || factura.fechaFactura.includes('-05-') || factura.fechaFactura.includes('-06-'))
                  data.trimestre2 += importe;
                else if(factura.fechaFactura.includes('-07-') || factura.fechaFactura.includes('-08-') || factura.fechaFactura.includes('-09-'))
                  data.trimestre3 += importe;
                else if(factura.fechaFactura.includes('-10-') || factura.fechaFactura.includes('-11-') || factura.fechaFactura.includes('-12-'))
                  data.trimestre4 += importe;

                data.total += importe;
              });

              if(data.total >= 3005.06)
                resultado.push(data);
            });

            resultado.sort((a, b) => b.total - a.total);
            this.data347 = resultado;
          },
          copiar347(){
            let csv = "Proveedor;CIF;T1;T2;T3;T4;Total\n";
            this.data347.forEach(p => {
              csv += p.nombre + ";" + p.cif + ";" + p.trimestre1.toFixed(2) + ";" + p.trimestre2.toFixed(2) + ";" + p.trimestre3.toFixed(2) + ";" + p.trimestre4.toFixed(2) + ";" + p.total.toFixed(2) + "\n";
            });
            // Fila de totales
            let t = this.total347;
            csv += "TOTAL;;" + t.t1.toFixed(2) + ";" + t.t2.toFixed(2) + ";" + t.t3.toFixed(2) + ";" + t.t4.toFixed(2) + ";" + t.total.toFixed(2) + "\n";

            navigator.clipboard.writeText(csv).then(() => {
              this.$bvToast.toast('Datos del 347 copiados al portapapeles', { title: 'Copiado', variant: 'success', solid: true });
            }).catch(() => {
              this.$bvToast.toast('Error al copiar', { title: 'Error', variant: 'danger', solid: true });
            });
          },
          descargar347CSV(){
            let csv = "Proveedor;CIF;T1;T2;T3;T4;Total\n";
            this.data347.forEach(p => {
              csv += p.nombre + ";" + p.cif + ";" + p.trimestre1.toFixed(2) + ";" + p.trimestre2.toFixed(2) + ";" + p.trimestre3.toFixed(2) + ";" + p.trimestre4.toFixed(2) + ";" + p.total.toFixed(2) + "\n";
            });
            let t = this.total347;
            csv += "TOTAL;;" + t.t1.toFixed(2) + ";" + t.t2.toFixed(2) + ";" + t.t3.toFixed(2) + ";" + t.t4.toFixed(2) + ";" + t.total.toFixed(2) + "\n";

            let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            let link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'modelo_347_' + this.anyo347 + '.csv';
            link.click();
          },
          copiarTrimestres(){

            var csv = "Empresa;1 Trimestre;2 Trimestre;3 Trimestre;4 Trimestre;Total"+"\n";          

            let proveedores346 = [];

            this.proveedores.forEach(proveedor => {
              let dataProveedor = {nombre: proveedor.nombre,trimestre1:0,trimestre2:0,trimestre3:0,trimestre4:0,total:0};
              this.listadoFacturas.forEach(factura => {

                const proveedorCondicion = proveedor.id === factura.idProveedor;
                const anyoCondicion = factura.fechaFactura.includes(this.anyoTrimestre);

                if(proveedorCondicion && anyoCondicion)
                {
                  if(factura.fechaFactura.includes('-01-') || factura.fechaFactura.includes('-02-') || factura.fechaFactura.includes('-03-'))
                  {
                    dataProveedor.trimestre1 +=  parseFloat(factura.total);
                    dataProveedor.total +=  parseFloat(factura.total);
                  }
                  else if(factura.fechaFactura.includes('-04-') || factura.fechaFactura.includes('-05-') || factura.fechaFactura.includes('-06-'))
                  {
                    dataProveedor.trimestre2 +=  parseFloat(factura.total);
                    dataProveedor.total +=  parseFloat(factura.total);
                  }
                  else if(factura.fechaFactura.includes('-07-') || factura.fechaFactura.includes('-08-') || factura.fechaFactura.includes('-09-'))
                  {
                    dataProveedor.trimestre3 +=  parseFloat(factura.total);
                    dataProveedor.total +=  parseFloat(factura.total);
                  }
                  else if(factura.fechaFactura.includes('-10-') || factura.fechaFactura.includes('-11-') || factura.fechaFactura.includes('-12-'))
                  {
                    dataProveedor.trimestre4 +=  parseFloat(factura.total);
                    dataProveedor.total +=  parseFloat(factura.total);
                  }
                  
                }
              });

              proveedores346.push(dataProveedor);
            });

           
            proveedores346.forEach(proveedor => {
              if(proveedor.total >= 3005.06)
              {
                csv += proveedor.nombre + ";" + proveedor.trimestre1.toFixed(2) + ";" + proveedor.trimestre2.toFixed(2) + ";" + proveedor.trimestre3.toFixed(2) + ";"
                + proveedor.trimestre4.toFixed(2) + ";" + proveedor.total.toFixed(2) + "\n";
              }
            });

            navigator.clipboard.writeText(csv).then(() => {
              this.$bvToast.toast('Datos copiados al portapapeles', {
                title: 'Copiado',
                variant: 'success',
                solid: true,
              });
            }).catch(() => {
              this.$bvToast.toast('Error al copiar al portapapeles', {
                title: 'Error',
                variant: 'danger',
                solid: true,
              });
            });

          }
        },
         mounted() {
          this.loadItems();
          this.updateLiveTime();
          this.liveTimeInterval = setInterval(this.updateLiveTime, 60000);
          setTimeout(()=>{
            this.cargando = false;
          }, 2000);
        },
        beforeDestroy() {
          if (this.liveTimeInterval) {
            clearInterval(this.liveTimeInterval);
            this.liveTimeInterval = null;
          }
        },
        watch: {
          buscar(){
            if(this.buscar == "")
              this.countItemView = this.defaultItemView;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          pagadoSelect(){
            this.sortBy = null;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          categoriaSelect(){
            this.sortBy = null;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          proveedorSelect(){
            this.sortBy = null;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          anyoTrimestre(){
            this.calcularTrimestre();
          },
          anyo347(){
            this.calcular347();
          },
          empresaSelect(){            
            this.sortBy = null;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          fechaDesdeSelect(){
            this.buscarFuncion();
            this.guardarFiltro();
          },
          fechaHastaSelect(){
            this.buscarFuncion();
            this.guardarFiltro();
          },
          inputProveedor(){
            if(this.inputProveedor != null){

              if(this.inputProveedor.plazo != null)
                this.inputPlazo = this.inputProveedor.plazo;
              else
                this.inputPlazo = '';
              
              if(this.inputProveedor.empresa != null)
              {
                //let empresaEncontrada = this.empresasGastos.find(objeto => objeto.nombre.includes(this.inputProveedor.empresa));
                const empresaEncontrada = this.empresasGastos.find(objeto => objeto.alias === this.inputProveedor.empresa);
                
                if(empresaEncontrada)
                {
                  this.inputEmpresa = empresaEncontrada;
                }
              }

              this.listadoPedidosMostrar = [];
              /*this.listadoPedidosMostrar = this.listadoPedidos
              .filter(item => item.idProveedor == this.inputProveedor.id && item.idGasto === null)
              .map(item => ({ ...item, check: false }));*/

              this.listadoPedidos.forEach(pedido => {
                if(pedido.idProveedor == this.inputProveedor.id && pedido.fechaPedido != "")
                {

                  pedido.listaMateriales.map(item => ({ ...item, visible: true }));

                  let valido = false;
                  if(pedido.idGasto === null)
                    valido = true;
                  else
                  {

                    pedido.listaMateriales.forEach(material => {
                      if(material.cantidadFacturada == undefined || material.cantidadFacturada == "")
                        valido = true;
                      else if(material.cantidadFacturada < material.cantidad)
                        valido = true;
                    });

                  }

                  pedido.check = false;

                  if(valido)
                  {
                    this.listadoPedidosMostrar.push(pedido);

                    this.listadoPedidosMostrar.forEach(pedido => {
                      pedido.listaMateriales.forEach(material => {
                        if(material.cantidadFacturada !== undefined && material.cantidadFacturada == material.cantidad)
                          material.visible = false;
                        else
                          material.visible = true;
                      });

                    });
                  }

                }
              });

            }
            else{
              this.inputPlazo = '';
              this.listadoPedidosMostrar = [];
            }

            this.guardarFiltro();
              

          },
          event(){
            let facturaEncontrada = this.listadoFacturas.find(factura => factura.id == this.event.id);

            if (facturaEncontrada) {
              this.editFactura(facturaEncontrada);
            } else {
                //console.log('No se encontró la factura');
            }
          }
        },
        setup() {

           /* const CALENDAR_APP_STORE_MODULE_NAME = 'calendar'

            // Register module
            if (!store.hasModule(CALENDAR_APP_STORE_MODULE_NAME)) store.registerModule(CALENDAR_APP_STORE_MODULE_NAME, calendarStoreModule)

            // UnRegister on leave
            onUnmounted(() => {
              if (store.hasModule(CALENDAR_APP_STORE_MODULE_NAME)) store.unregisterModule(CALENDAR_APP_STORE_MODULE_NAME)
            })

            const {
              refCalendar,
              isCalendarOverlaySidebarActive,
              event,
              clearEventData,
              addEvent,
              updateEvent,
              removeEvent,
              fetchEvents,
              refetchEvents,
              calendarOptions,
              fetchCalendarsColor,

              // ----- UI ----- //
              isEventHandlerSidebarActive,
            } = useCalendar()

            const { fetchCalendarOptions } = useCalendarSidebar();

            fetchEvents()

            return {
              refCalendar,
              isCalendarOverlaySidebarActive,
              event,
              clearEventData,
              addEvent,
              updateEvent,
              removeEvent,
              refetchEvents,
              calendarOptions,
              fetchCalendarOptions,
              fetchCalendarsColor,

              // ----- UI ----- //
              isEventHandlerSidebarActive,
            }*/
          },
      }
    </script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@500;600;700&display=swap');

// ══════════════════════════════════════════════════════════════
// MODERN ERP — GASTOS DE PROVEEDOR V2
// Holded × Notion · warm cream, subtle shadows, refined data
// ══════════════════════════════════════════════════════════════

// Surfaces
$gp3-bg:        #FBFAF7;       // warm cream paper
$gp3-surface:   #FFFFFF;       // card
$gp3-surface-2: #F7F6F2;       // inset
$gp3-border:    #ECEAE6;       // hairline
$gp3-divider:   #F1EFEB;
$gp3-input-bg:  #FBFAF7;

// Text
$gp3-ink:       #0F172A;       // headings, primary
$gp3-text:      #1F2937;       // body
$gp3-mute:      #6B7280;       // labels
$gp3-soft:      #9CA3AF;       // dim

// Semantic
$gp3-emerald:    #0E9F6E;
$gp3-emerald-bg: #DCFCE7;
$gp3-coral:      #EF4444;
$gp3-coral-bg:   #FEE2E2;
$gp3-amber:      #F59E0B;
$gp3-amber-bg:   #FEF3C7;
$gp3-indigo:     #4F46E5;
$gp3-indigo-bg:  #E0E7FF;
$gp3-sky:        #0284C7;
$gp3-sky-bg:     #E0F2FE;

// Geometry
$gp3-r:    12px;
$gp3-r-sm: 8px;
$gp3-shadow: 0 1px 0 rgba(15, 23, 42, 0.04), 0 2px 6px rgba(15, 23, 42, 0.04);

.gp3 {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: $gp3-bg;
  color: $gp3-text;
  margin: -2rem;
  padding: 28px 32px 56px;
  min-height: calc(100vh - 4rem);
  font-feature-settings: "ss01", "cv11";

  *, *::before, *::after { box-sizing: border-box; }

  // ──────────── HEADER ────────────
  .gp3-header { margin-bottom: 24px; }

  .gp3-crumbs {
    font-size: 12px;
    font-weight: 500;
    color: $gp3-mute;
    margin-bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 8px;

    .gp3-crumb-sep { opacity: 0.5; font-size: 13px; }
    .gp3-crumb-current { color: $gp3-ink; font-weight: 600; }
  }

  .gp3-header-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 24px;
    flex-wrap: wrap;
  }

  .gp3-title {
    font-family: 'Manrope', sans-serif;
    font-size: 30px;
    font-weight: 800;
    color: $gp3-ink;
    line-height: 1.1;
    letter-spacing: -0.025em;
    margin: 0 0 6px;
  }

  .gp3-subtitle {
    font-size: 13px;
    font-weight: 500;
    color: $gp3-mute;
    margin: 0;

    strong { color: $gp3-ink; font-weight: 700; }
  }

  .gp3-header-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  // ──────────── BUTTONS ────────────
  .gp3-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 38px;
    padding: 0 16px;
    background: $gp3-surface;
    border: 1px solid $gp3-border;
    border-radius: $gp3-r-sm;
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: $gp3-text;
    cursor: pointer;
    transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;

    i { font-size: 12px; }

    &:hover {
      background: $gp3-surface-2;
      border-color: $gp3-soft;
    }

    &--primary {
      background: $gp3-ink;
      border-color: $gp3-ink;
      color: #fff;

      &:hover {
        background: lighten($gp3-ink, 8%);
        border-color: lighten($gp3-ink, 8%);
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);
      }
    }

    &--ghost {
      background: $gp3-surface;
    }

    &--sm { height: 32px; padding: 0 12px; font-size: 12px; }
  }

  // ──────────── KPI CARDS ────────────
  .gp3-kpis {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
    margin-bottom: 18px;

    @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
    @media (max-width: 600px) { grid-template-columns: 1fr; }
  }

  .gp3-kpi {
    position: relative;
    background: $gp3-surface;
    border: 1px solid $gp3-border;
    border-radius: $gp3-r;
    padding: 18px 18px 14px;
    box-shadow: $gp3-shadow;
    transition: all 200ms ease;
    overflow: hidden;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04), 0 8px 20px rgba(15, 23, 42, 0.06);
    }
  }

  .gp3-kpi-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .gp3-kpi-icon {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: $gp3-r-sm;
    font-size: 14px;

    &--indigo  { background: $gp3-indigo-bg;  color: $gp3-indigo; }
    &--emerald { background: $gp3-emerald-bg; color: $gp3-emerald; }
    &--danger  { background: $gp3-coral-bg;   color: $gp3-coral; }
    &--amber   { background: $gp3-amber-bg;   color: $gp3-amber; }
    &--sky     { background: $gp3-sky-bg;     color: $gp3-sky; }
    &--ink     { background: rgba(15,23,42,0.06); color: $gp3-ink; }
  }

  .gp3-kpi-trend {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 999px;

    &--up   { color: $gp3-emerald; background: $gp3-emerald-bg; }
    &--down { color: $gp3-coral;   background: $gp3-coral-bg; }
    &--flat { color: $gp3-mute;    background: $gp3-surface-2; }

    i { font-size: 10px; }
  }

  .gp3-kpi-value {
    font-family: 'Manrope', sans-serif;
    font-size: 32px;
    font-weight: 800;
    color: $gp3-ink;
    line-height: 1.05;
    letter-spacing: -0.03em;
    margin-bottom: 4px;
    font-feature-settings: "tnum";

    .gp3-kpi-unit {
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-weight: 600;
      color: $gp3-mute;
      margin-left: 4px;
      letter-spacing: 0;
    }
  }

  .gp3-kpi-label {
    font-size: 12px;
    font-weight: 500;
    color: $gp3-mute;
  }

  .gp3-kpi-spark {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 28px;
    opacity: 0.55;
    pointer-events: none;
  }

  // ──────────── CARD ────────────
  .gp3-card {
    background: $gp3-surface;
    border: 1px solid $gp3-border;
    border-radius: $gp3-r;
    box-shadow: $gp3-shadow;
    margin-bottom: 18px;
    overflow: hidden;

    &--table { padding-bottom: 0; }
  }

  .gp3-card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 18px 22px;
    border-bottom: 1px solid $gp3-divider;
    flex-wrap: wrap;
  }

  .gp3-card-title {
    font-family: 'Manrope', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $gp3-ink;
    letter-spacing: -0.01em;
    margin: 0 0 2px;
  }

  .gp3-card-sub {
    font-size: 12px;
    font-weight: 500;
    color: $gp3-mute;
    margin: 0;
  }

  .gp3-card-actions {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  // ──────────── TRIMESTRES ────────────
  .gp3-trim-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0;

    @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  }

  .gp3-trim {
    padding: 18px 22px;
    border-right: 1px solid $gp3-divider;

    &:last-child { border-right: 0; }

    @media (max-width: 900px) {
      &:nth-child(2n) { border-right: 0; }
      &:nth-child(-n+2) { border-bottom: 1px solid $gp3-divider; }
    }
  }

  .gp3-trim-head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
  }

  .gp3-trim-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 22px;
    background: $gp3-indigo-bg;
    color: $gp3-indigo;
    border-radius: 6px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 700;
  }

  .gp3-trim-name {
    font-size: 11px;
    font-weight: 500;
    color: $gp3-mute;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  .gp3-trim-value {
    font-family: 'Manrope', sans-serif;
    font-size: 24px;
    font-weight: 800;
    color: $gp3-ink;
    letter-spacing: -0.025em;
    line-height: 1;
    font-feature-settings: "tnum";

    .gp3-trim-currency {
      font-family: 'Inter', sans-serif;
      font-size: 12px;
      font-weight: 600;
      color: $gp3-mute;
      margin-left: 4px;
      letter-spacing: 0;
    }
  }

  // ──────────── SEARCH ────────────
  .gp3-search {
    position: relative;
    flex: 0 0 320px;
    max-width: 100%;
  }

  .gp3-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: $gp3-soft;
    font-size: 12px;
    pointer-events: none;
  }

  .gp3-search input {
    width: 100%;
    height: 38px;
    padding: 0 36px 0 34px;
    background: $gp3-input-bg;
    border: 1px solid $gp3-border;
    border-radius: $gp3-r-sm;
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    color: $gp3-text;
    transition: all 150ms ease;

    &::placeholder { color: $gp3-soft; }

    &:focus {
      outline: none;
      border-color: $gp3-ink;
      background: $gp3-surface;
      box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06);
    }
  }

  .gp3-search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    border: 0;
    background: $gp3-divider;
    color: $gp3-mute;
    border-radius: 50%;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;

    &:hover { background: $gp3-coral; color: #fff; }
  }

  // ──────────── FILTERS ────────────
  .gp3-filters {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
    padding: 18px 22px;
    border-bottom: 1px solid $gp3-divider;
    background: $gp3-surface-2;

    @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
    @media (max-width: 600px) { grid-template-columns: 1fr; }
  }

  .gp3-filter-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    color: $gp3-mute;
    margin-bottom: 6px;
    letter-spacing: 0.02em;
  }

  // Date input
  .gp3-input,
  input.gp3-input,
  .gp3-input.flatpickr-input {
    display: block !important;
    width: 100% !important;
    height: 36px !important;
    padding: 0 12px !important;
    background: $gp3-surface !important;
    border: 1px solid $gp3-border !important;
    border-radius: $gp3-r-sm !important;
    font-family: 'Inter', sans-serif !important;
    font-size: 13px !important;
    color: $gp3-text !important;
    line-height: 34px !important;
    transition: all 150ms ease !important;
    box-shadow: none !important;

    &:focus, &:focus-visible {
      outline: none !important;
      border-color: $gp3-ink !important;
      box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06) !important;
    }
  }

  // v-select
  .gp3-vselect {
    .vs__dropdown-toggle {
      background: $gp3-surface !important;
      border: 1px solid $gp3-border !important;
      border-radius: $gp3-r-sm !important;
      min-height: 36px;
      padding: 0 8px 0 6px;
      box-shadow: none !important;
      transition: all 150ms ease;
    }
    &.vs--open .vs__dropdown-toggle,
    .vs__dropdown-toggle:focus-within {
      border-color: $gp3-ink !important;
      box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06) !important;
    }
    .vs__selected-options { padding: 0; }
    .vs__selected, .vs__search, .vs__search:focus {
      font-family: 'Inter', sans-serif;
      font-size: 13px;
      color: $gp3-text;
      padding: 0 6px;
      margin: 0;
      line-height: 34px;
      height: 34px;
    }
    .vs__open-indicator { fill: $gp3-soft; transform: scale(0.75); }
    .vs__clear { display: none; }
    .vs__dropdown-menu {
      background: $gp3-surface;
      border: 1px solid $gp3-border;
      border-radius: $gp3-r-sm;
      box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
      padding: 4px;
      margin-top: 4px;
    }
    .vs__dropdown-option {
      font-family: 'Inter', sans-serif;
      font-size: 13px;
      color: $gp3-text;
      padding: 8px 10px;
      border-radius: 6px;

      &--highlight { background: $gp3-surface-2; color: $gp3-ink; }
    }
  }

  .gp3-vselect--year .vs__dropdown-toggle { width: 110px; }

  // ──────────── TABLE ────────────
  .gp3-table-wrap {
    overflow-x: auto;
    background: $gp3-surface;
  }

  .gp3-table {
    width: 100%;
    border-collapse: collapse;
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    color: $gp3-text;

    thead th {
      background: $gp3-surface;
      color: $gp3-mute;
      font-size: 11px;
      font-weight: 600;
      text-align: left;
      padding: 12px 14px;
      border-bottom: 1px solid $gp3-border;
      white-space: nowrap;
      letter-spacing: 0.02em;

      &.th-r { text-align: right; }
      &.th-c { text-align: center; }
      &.th-stripe { width: 6px; padding: 0; }
    }

    tbody tr {
      border-bottom: 1px solid $gp3-divider;
      transition: background 150ms ease;

      &:hover {
        background: $gp3-surface-2;
      }

      &:last-child { border-bottom: 0; }

      &.row-warning .gp3-row-stripe { background: $gp3-amber; }
      &.row-danger  .gp3-row-stripe { background: $gp3-coral; }
      &.row-success .gp3-row-stripe { background: $gp3-emerald; }
    }

    td {
      padding: 12px 14px;
      vertical-align: middle;

      &.td-r { text-align: right; }
      &.td-c { text-align: center; }
      &.td-stripe { padding: 0; width: 6px; position: relative; }
    }
  }

  // Row stripe (left edge color indicator)
  .gp3-row-stripe {
    display: block;
    width: 3px;
    height: 28px;
    background: $gp3-divider;
    border-radius: 0 2px 2px 0;
    margin-left: 0;
  }

  // Empresa pill
  .gp3-empresa-pill {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }

  .gp3-empresa-init {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;

    &--indigo  { background: $gp3-indigo-bg;  color: $gp3-indigo; }
    &--emerald { background: $gp3-emerald-bg; color: $gp3-emerald; }
    &--coral   { background: $gp3-coral-bg;   color: $gp3-coral; }
    &--amber   { background: $gp3-amber-bg;   color: $gp3-amber; }
    &--sky     { background: $gp3-sky-bg;     color: $gp3-sky; }
    &--ink     { background: rgba(15,23,42,0.06); color: $gp3-ink; }
  }

  .gp3-empresa-name {
    font-weight: 600;
    color: $gp3-ink;
  }

  .td-prov { color: $gp3-text; }
  .td-codigo {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: $gp3-ink;
    letter-spacing: 0.01em;
  }
  .td-fecha {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: $gp3-mute;
  }
  .td-amount {
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px;
    color: $gp3-ink;

    strong { font-weight: 700; }
    .gp3-currency { color: $gp3-soft; font-weight: 500; margin-left: 2px; }
  }

  .is-debt {
    font-family: 'JetBrains Mono', monospace;
    color: $gp3-coral !important;
    strong { font-weight: 700; }
    .gp3-currency { color: $gp3-coral; opacity: 0.7; }
  }

  // Vencimiento
  .gp3-vence {
    display: inline-block;
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: $gp3-mute;
    padding: 3px 8px;
    border-radius: 6px;

    &.is-warning { color: $gp3-amber; background: $gp3-amber-bg; font-weight: 600; }
    &.is-danger  { color: $gp3-coral; background: $gp3-coral-bg; font-weight: 700; text-decoration: line-through; }
    &.is-success { color: $gp3-emerald; background: $gp3-emerald-bg; }
  }

  // Status badges (Pagado / Pendiente)
  .gp3-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 12px;
    border-radius: 999px;
    font-family: 'Inter', sans-serif;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 150ms ease;

    .gp3-status-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }

    &--paid {
      background: $gp3-emerald-bg;
      color: $gp3-emerald;

      .gp3-status-dot { background: $gp3-emerald; }
      &:hover { background: lighten($gp3-emerald-bg, 1%); }
    }

    &--unpaid {
      background: $gp3-coral-bg;
      color: $gp3-coral;

      .gp3-status-dot { background: $gp3-coral; animation: gp3-pulse 2s infinite; }
      &:hover { background: lighten($gp3-coral-bg, 1%); }
    }
  }

  // Notas
  .gp3-note-icon {
    color: $gp3-indigo;
    cursor: help;
    font-size: 13px;
  }

  .gp3-dim { color: $gp3-soft; }
  .gp3-currency { font-size: 11px; }

  // Icon buttons
  .td-actions { white-space: nowrap; }

  .gp3-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid $gp3-border;
    background: $gp3-surface;
    border-radius: 8px;
    color: $gp3-mute;
    cursor: pointer;
    transition: all 150ms ease;
    font-size: 11px;
    margin: 0 2px;

    &:hover {
      background: $gp3-surface-2;
      color: $gp3-ink;
      border-color: $gp3-soft;
    }

    &--danger:hover {
      background: $gp3-coral-bg;
      color: $gp3-coral;
      border-color: $gp3-coral;
    }
  }

  // Empty state
  .gp3-empty {
    text-align: center;
    padding: 64px 24px;

    .gp3-empty-inner {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      color: $gp3-soft;

      i { font-size: 32px; }
      p { margin: 0; font-size: 13px; font-weight: 500; }
    }
  }

  // Animations
  @keyframes gp3-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.4; transform: scale(0.7); }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
}

// Dark mode (for Vuexy dark layout integration)
.dark-layout .gp3 {
  background: #161616;
  color: #d0d2d6;

  .gp3-title { color: #e4e6eb; }
  .gp3-subtitle { color: #8e9099; strong { color: #e4e6eb; } }
  .gp3-crumbs .gp3-crumb-current { color: #e4e6eb; }

  .gp3-card,
  .gp3-kpi { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .gp3-card-head { border-bottom-color: #2c2c2c; }
  .gp3-card-title { color: #e4e6eb; }
  .gp3-card-sub { color: #8e9099; }

  .gp3-kpi-value { color: #e4e6eb; }
  .gp3-kpi-label { color: #8e9099; }

  .gp3-trim { border-right-color: #2c2c2c; }
  .gp3-trim-value { color: #e4e6eb; }

  .gp3-filters { background: #1a1a1a; border-bottom-color: #2c2c2c; }
  .gp3-filter-label { color: #8e9099; }

  .gp3-search input {
    background: #1f1f1f;
    border-color: #2c2c2c;
    color: #d0d2d6;
    &:focus { background: #242424; }
  }

  .gp3-input {
    background: #1f1f1f !important;
    border-color: #2c2c2c !important;
    color: #d0d2d6 !important;
  }

  .gp3-vselect .vs__dropdown-toggle {
    background: #1f1f1f !important;
    border-color: #2c2c2c !important;
  }
  .gp3-vselect .vs__selected,
  .gp3-vselect .vs__search { color: #d0d2d6; }
  .gp3-vselect .vs__dropdown-menu { background: #242424; border-color: #3a3a3a; }
  .gp3-vselect .vs__dropdown-option { color: #d0d2d6; }
  .gp3-vselect .vs__dropdown-option--highlight { background: #2c2c2c; color: #fff; }

  .gp3-table thead th { background: #1f1f1f; color: #8e9099; border-bottom-color: #2c2c2c; }
  .gp3-table tbody tr { border-bottom-color: #2c2c2c; }
  .gp3-table tbody tr:hover { background: #242424; }
  .gp3-table td { color: #d0d2d6; }
  .td-codigo, .gp3-empresa-name { color: #e4e6eb; }
  .td-amount { color: #e4e6eb; }

  .gp3-icon-btn {
    background: #1f1f1f;
    border-color: #2c2c2c;
    color: #8e9099;
    &:hover { background: #2a2a2a; color: #e4e6eb; border-color: #3a3a3a; }
  }

  .gp3-btn {
    background: #1f1f1f;
    border-color: #2c2c2c;
    color: #d0d2d6;
    &:hover { background: #2a2a2a; }
    // Primario: gris más claro que la superficie en vez de blanco
    &--primary {
      background: #2c2c2c;
      color: #e4e6eb;
      border-color: #3a3a3a;
      &:hover { background: #3a3a3a; border-color: #4a4a4a; box-shadow: none; }
    }
  }

  // Tabla
  .gp3-table-wrap { background: #1f1f1f; }
  .gp3-row-stripe { background: #2c2c2c; }
  .td-prov { color: #d0d2d6; }
  .gp3-trim { border-bottom-color: #2c2c2c; }

  // Buscador / inputs: foco sin tinta oscura
  .gp3-search input:focus { border-color: #3a3a3a; box-shadow: none; }
  .gp3-search-clear { background: #2c2c2c; color: #b4b7bd; }
  .gp3-input:focus,
  .gp3-input:focus-visible { border-color: #3a3a3a !important; box-shadow: none !important; }
  .gp3-vselect.vs--open .vs__dropdown-toggle,
  .gp3-vselect .vs__dropdown-toggle:focus-within { border-color: #3a3a3a !important; box-shadow: none !important; }

  // Tintes pastel sólidos -> rgba para que no queden claros
  .gp3-kpi-icon--indigo, .gp3-empresa-init--indigo, .gp3-trim-mark { background: rgba(79, 70, 229, 0.18); color: #818cf8; }
  .gp3-kpi-icon--emerald, .gp3-empresa-init--emerald { background: rgba(14, 159, 110, 0.16); }
  .gp3-kpi-icon--danger, .gp3-empresa-init--coral { background: rgba(239, 68, 68, 0.16); }
  .gp3-kpi-icon--amber, .gp3-empresa-init--amber { background: rgba(245, 158, 11, 0.16); }
  .gp3-kpi-icon--sky, .gp3-empresa-init--sky { background: rgba(2, 132, 199, 0.18); color: #38bdf8; }
  .gp3-kpi-icon--ink, .gp3-empresa-init--ink { background: rgba(255, 255, 255, 0.06); color: #e4e6eb; }

  .gp3-kpi-trend--up { background: rgba(14, 159, 110, 0.16); }
  .gp3-kpi-trend--down { background: rgba(239, 68, 68, 0.16); }
  .gp3-kpi-trend--flat { background: #242424; color: #8e9099; }

  .gp3-vence.is-warning { background: rgba(245, 158, 11, 0.16); }
  .gp3-vence.is-danger { background: rgba(239, 68, 68, 0.16); }
  .gp3-vence.is-success { background: rgba(14, 159, 110, 0.16); }

  .gp3-status--paid { background: rgba(14, 159, 110, 0.16); &:hover { background: rgba(14, 159, 110, 0.24); } }
  .gp3-status--unpaid { background: rgba(239, 68, 68, 0.16); &:hover { background: rgba(239, 68, 68, 0.24); } }

  .gp3-icon-btn--danger:hover { background: rgba(239, 68, 68, 0.16); color: #EF4444; border-color: #EF4444; }
  .gp3-note-icon { color: #818cf8; }
}
</style>
